<template>
    <div style="height:68rem; background-image:url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NxF4FXt.png');background-size:100% 100%;">
        <div style="margin-left:10%; width: 80%;">
            <van-button class="jumpButton"
                        url="https://uf.jr.jd.com/up/redenjdv2/jkl.html?pageCode=CE688B93EA&sourceID=318&actflag=CE688B93EA&isPay=Y&actCode=CE688B93EA&cpachflag=lLSpEvfX&linkId=ZTCPS112007802167"></van-button>
            <van-field v-model="code" placeholder="请输入京东用户名" input-align="center" class="inputField"></van-field>
            <van-button class="confirmButton" @click="getCouponByJdPin"></van-button>
        </div>

        <van-dialog v-model="qrVisible" confirm-button-text="长按识别二维码关注" close-on-click-overlay>
            <img src="http://jho2o.oss-cn-beijing.aliyuncs.com/test/2O3B53K5.jpg" width="100%"/>
        </van-dialog>

        <van-dialog v-model="dialogVisible" confirm-button-text="关闭">
            <div style="min-height: 35rem; background-image:url('http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NxF361C.jpg');background-size:100% 100%;">
                <img :src="couponImg" style="width: 7rem; padding: 28rem 15rem 0 3rem;"/>
            </div>
        </van-dialog>
    </div>
</template>

<script>
    import happyPotatoAPI from '@/api/happyPotato';

    export default {
        data() {
            return {
                code: null,
                qrVisible: false,
                dialogVisible: false,
                couponImg: '',
            }
        },
        methods: {
            getCouponByJdPin() {
                if (!this.code) {
                    this.$toast("京东用户名为空");
                    return;
                }
                this.$toast.loading({forbidClick: true});
                happyPotatoAPI.getCouponByJdPin(this.code).then((result) => {
                    // 领取成功，弹窗
                    this.dialogVisible = true;
                    this.couponImg = result.data;
                    this.$toast.clear();
                }).catch(() => {
                });
            },
        },
        created() {
            document.title = "蜂窝圈";
        }
    }

</script>

<style lang="scss" scoped>

    .jumpButton {
        margin-top: 14.2rem;
        width: 100%;
        height: 3rem;
        background-image: url("http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NxEYfuw.png");
        background-size: 100% 100%;
        border-style: none;
        border-radius: 2rem;
    }

    .inputField {
        margin-top: 21rem;
        width: 100%;
        height: 3.3rem;
        border-radius: 2rem;
        text-align: center;
        border: 0;
    }

    .confirmButton {
        margin-top: 0.8rem;
        width: 100%;
        height: 3rem;
        background-image: url("http://jho2o.oss-cn-beijing.aliyuncs.com/test/2NxEYeA5.png");
        background-size: 100% 100%;
        border-style: none;
        border-radius: 2rem;
    }

</style>
